import * as tslib_1 from "tslib";
import convertPersonaToRecipientPersonaProps from '../utils/convertPersonaToRecipientPersonaProps';
import findReadWriteRecipient from 'owa-readwrite-recipient-well/lib/actions/findReadWriteRecipient';
export default function getSuggestions(filterText, viewState, recipient) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(viewState.queryString === filterText)) return [3 /*break*/, 2];
                    return [4 /*yield*/, findReadWriteRecipient(viewState, filterText, false /*searchDirectory*/)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/, convertPersonaToRecipientPersonaProps(viewState.findResultSet)];
            }
        });
    });
}
//# sourceMappingURL=getSuggestions.js.map